import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
//import { Section, Page, Cell, Switch } from '@twa-dev/mark42';
import SimpleBarReact from 'simplebar-react';
// import WebApp from '@twa-dev/sdk';
// import { MainButton } from '@twa-dev/sdk/dist/react';
import { Accordion, Button, Card, Form, Image, useAccordionButton } from 'react-bootstrap';
import Flex from 'components/common/Flex';
//import { currency } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { Link } from 'react-router-dom';
import Fuse from 'fuse.js';
import FalconLightBox from 'components/common/FalconLightBox';

const CustomToggle = ({ children, eventKey, data }) => {
 const decoratedOnClick = useAccordionButton(eventKey);
 return (
  <Flex alignItems="center" key={data.id} className="cursor-pointer">
   <FalconLightBox image={data.image}>
    <Image rounded width={40} height={40} src={data.image} />
   </FalconLightBox>

   <Flex justifyContent="between" alignItems="center" className="ms-1 flex-1" onClick={decoratedOnClick}>
    <div>
     <h5 className="text-truncate m-0 fs-0" style={{ maxWidth: '50vw' }}>
      {data.name}
     </h5>
     <Flex className="position-relative" align="center">
      <p className="mb-0 fs--1 text-400 line-height-1">
       <strong>{data.price}</strong>
      </p>
     </Flex>
    </div>
   </Flex>
   {children}
  </Flex>
 );
};

const products = [
 {
  id: 0,
  name: 'Telegram',
  price: 1000,
  description: 'Telegram',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 1,
  name: 'Facebook',
  price: 200,
  description: 'Facebook',
  icon: 'ban',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 2,
  name: 'Twitter',
  price: 300,
  description: 'Twitter',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 3,
  name: 'Instagram',
  price: 400,
  description: 'Instagram',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 4,
  name: 'Whatsapp',
  price: 500,
  description: 'Whatsapp',
  icon: 'ban',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 5,
  name: 'Youtube',
  price: 600,
  description: 'Youtube',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 6,
  name: 'Tiktok',
  price: 700,
  description: 'Tiktok',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 7,
  name: 'Linkedin',
  price: 800,
  description: 'Linkedin',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 8,
  name: 'Pinterest',
  price: 900,
  description: 'Pinterest',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 },
 {
  id: 9,
  name: 'Snapchat',
  price: 1000,
  description: 'Snapchat',
  icon: 'check',
  image: 'https://copservir.vtexassets.com/arquivos/ids/1070477/DOLEX-FORTE-OPTIZORB_F.png?v=638333468188870000'
 }
];

const Telegram = () => {
 const [value, setValue] = useState('');
 const [medicamentos, setMedicamentos] = useState([]);
 const [list, setList] = useState([]);
 // Initialize the Fuse instance with the product data
 const fuse = new Fuse(products, { keys: ['name'], threshold: 0.3 });

 const search = ({ target: { value } }) => {
  if (value === '') setMedicamentos([]);
  else setMedicamentos(fuse.search(value).map(({ item }) => item));
  setValue(value);
 };

 const sendList = product => !list.some(e => e.id === product.id) && setList([...list, product]);

 useEffect(() => {
  console.log(list, 'la lista se actualizo');
 }, [list]);

 useEffect(() => {
  // 'var(--tg-viewport-stable-height, 100vh)'
  // const data = WebApp.initDataUnsafe;
  // console.log(data, 'data');
 }, []);

 return (
  <>
   {/* <Page mode="secondary">
    <Section
     title="Title"
     description="Share your contacts with the community. It will help other members to reach you faster."
     header="Public contacts"
    >
     <Cell after={<Switch />} description="@Stambultsian">
      Twitter
     </Cell>
     <Cell after={<Switch />} description="@artursupertramp">
      Facebook
     </Cell>
     <Cell after={<Switch />} description="@ArthurStam">
      Telegram
     </Cell>
    </Section>

    <Section
     title="Title"
     description="Share your contacts with the community. It will help other members to reach you faster."
     header="Public contacts"
    >
     <Cell after={<Switch />} description="@Stambultsian">
      Twitter
     </Cell>
     <Cell after={<Switch />} description="@artursupertramp">
      Facebook
     </Cell>
     <Cell after={<Switch />} description="@ArthurStam">
      Telegram
     </Cell>
    </Section>

    <Section
     title="Title"
     description="Share your contacts with the community. It will help other members to reach you faster."
     header="Public contacts"
    >
     <Cell after={<Switch />} description="@Stambultsian">
      Twitter
     </Cell>
     <Cell after={<Switch />} description="@artursupertramp">
      Facebook
     </Cell>
     <Cell after={<Switch />} description="@ArthurStam">
      Telegram
     </Cell>
    </Section>
   </Page> */}

   {/* <MainButton text="Boton" onClick={() => alert('submitted')} /> */}

   <Card className="bottom-bar rounded-0" style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
    <Card.Header className="p-0 bg-300 border-top mt-3">
     <SimpleBarReact style={{ maxHeight: '200px' }}>
      <Accordion className="p-2" defaultActiveKey="0">
       {medicamentos.map(({ id, name, price, description, image, icon }) => (
        <>
         <Card className="mb-2" key={id}>
          <Card.Header className="py-2">
           <CustomToggle eventKey={id} data={{ id, name, price, description, image }}>
            <Button
             variant="falcon-primary"
             type="button"
             className="p-0 icon-item icon-item-sm"
             //disabled={rest?.disabled}
             onClick={() => sendList({ id, name, price, description, image })}
            >
             <FontAwesomeIcon icon={icon} />
            </Button>
           </CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey={id}>
           <Card.Body>
            <p>djaflkdsajfajlfjalfjldj;fl dsafkjfla;jflsajlf</p>
           </Card.Body>
          </Accordion.Collapse>
         </Card>
        </>
       ))}
      </Accordion>
     </SimpleBarReact>
    </Card.Header>
    <Card.Body className="py-2">
     <Form.Control
      value={value}
      onChange={search}
      id="search"
      placeholder="Search..."
      type="search"
      className="shadow-none"
      size="lg"
     />
    </Card.Body>
   </Card>
  </>
 );
};

Telegram.propTypes = {};

CustomToggle.propTypes = {
 children: PropTypes.node,
 eventKey: PropTypes.number,
 data: PropTypes.object
};

export default Telegram;
